var link_viewer_default = {
  "fontElementMap": "g-Jpj",
  "link": "hEuCV",
  "linkInEditor": "-qNw8",
  "linkInViewer": "uw4qb",
  "toolbarUrlContainer": "_35ePW",
  "toolbarUrl": "KMvDs",
  "toolbarUrlAnchor": "tXKQZ"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer.scss.js.map
